import React from 'react';
import { FaCar } from 'react-icons/fa';

export default function SafetySection() {
  return (
    <div className="w-full bg-[#f8f8f8] py-12 md:py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        {/* Heading */}
        <h2 className="text-3xl md:text-[42px] font-semibold text-gray-900 mb-8 md:mb-16 text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
          Dedication to safety
        </h2>

        {/* Features Grid - Mobile: horizontal scroll, Desktop: 3 columns */}
        <div className="flex md:grid md:grid-cols-3 gap-4 md:gap-16 overflow-x-auto md:overflow-x-visible pb-4 md:pb-0 snap-x snap-mandatory md:snap-none scrollbar-hide"
             style={{ WebkitOverflowScrolling: 'touch' }}>
          
          {/* Feature 1 */}
          <div className="flex-shrink-0 w-[85%] md:w-auto snap-center md:snap-none bg-white md:bg-transparent rounded-2xl md:rounded-none p-6 md:p-0 shadow-md md:shadow-none">
            <div className="mb-4 md:mb-6 flex justify-center md:justify-start">
              <div className="w-16 h-16 md:w-20 md:h-20">
                <svg className="w-full h-full" viewBox="0 0 80 80" fill="none">
                  <path d="M40 5L15 15V32.5C15 49.5 26.5 65.5 40 70C53.5 65.5 65 49.5 65 32.5V15L40 5Z" fill="#e71204"/>
                  <path d="M32 40L36.5 44.5L48 33" stroke="white" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
            </div>
            <h3 className="text-xl md:text-[22px] font-semibold text-gray-900 mb-2 md:mb-3 text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Carefully vetted drivers
            </h3>
            <p className="text-sm md:text-[16px] text-gray-700 leading-relaxed text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              We individually interview every Daytrip driver, so you can rest assured they meet our world-class standards.
            </p>
          </div>

          {/* Feature 2 */}
          <div className="flex-shrink-0 w-[85%] md:w-auto snap-center md:snap-none bg-white md:bg-transparent rounded-2xl md:rounded-none p-6 md:p-0 shadow-md md:shadow-none">
            <div className="mb-4 md:mb-6 flex justify-center md:justify-start">
              <FaCar className="w-16 h-16 md:w-20 md:h-20 text-[#e71204]" />
            </div>
            <h3 className="text-xl md:text-[22px] font-semibold text-gray-900 mb-2 md:mb-3 text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Clean, comfortable cars
            </h3>
            <p className="text-sm md:text-[16px] text-gray-700 leading-relaxed text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              We have strict vehicle standards, so you'll always get a modern one that's safe, clean, and comfortable.
            </p>
          </div>

          {/* Feature 3 */}
          <div className="flex-shrink-0 w-[85%] md:w-auto snap-center md:snap-none bg-white md:bg-transparent rounded-2xl md:rounded-none p-6 md:p-0 shadow-md md:shadow-none">
            <div className="mb-4 md:mb-6 flex justify-center md:justify-start">
              <div className="w-16 h-16 md:w-20 md:h-20">
                <svg className="w-full h-full" viewBox="0 0 80 80" fill="none">
                  <rect x="20" y="15" width="15" height="50" rx="2" fill="#e71204"/>
                  <rect x="45" y="25" width="15" height="40" rx="2" fill="#e71204"/>
                  <rect x="32.5" y="35" width="15" height="30" rx="2" fill="#e71204"/>
                  <path d="M15 65H65" stroke="#e71204" strokeWidth="3" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
            <h3 className="text-xl md:text-[22px] font-semibold text-gray-900 mb-2 md:mb-3 text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Local expertise
            </h3>
            <p className="text-sm md:text-[16px] text-gray-700 leading-relaxed text-center md:text-left" style={{ fontFamily: 'system-ui, -apple-system, sans-serif' }}>
              Our drivers know the rules of the road, so they can get you from A to B safely.
            </p>
          </div>
        </div>

        {/* Mobile Scroll Indicators - Dots */}
        <div className="flex justify-center gap-2 mt-4 md:hidden">
          <div className="w-2 h-2 rounded-full bg-[#e71204]"></div>
          <div className="w-2 h-2 rounded-full bg-gray-300"></div>
          <div className="w-2 h-2 rounded-full bg-gray-300"></div>
        </div>

        {/* Scrollbar hide styles */}
        <style jsx>{`
          .scrollbar-hide::-webkit-scrollbar {
            display: none;
          }
          .scrollbar-hide {
            -ms-overflow-style: none;
            scrollbar-width: none;
          }
        `}</style>
      </div>
    </div>
  );
}